import 'slick-carousel/slick/slick.min';

export default {
  init() {

    if ( document.querySelector( '.js-slider' ) == null ) {
      return;
    }

    $( '.js-icon-pagination button' ).on( 'click', this.iconPagination );

    const sliders = {
      'copy-slider-content-image': {
        fade: true,
        // arrows: false,
        asNavFor: '.js-slider-group',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="icon-arrow icon-arrow-down el-desktop"></span><span class="icon-arrow icon-arrow-left el-mobile"></span><span class="arrow-text">Prev</span></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="icon-arrow icon-arrow-up el-desktop"></span><span class="icon-arrow icon-arrow-right el-mobile"></span><span class="arrow-text">Next</span></button>',
      },
      'copy-slider-image': {
        arrows: false,
        fade: true,
        asNavFor: '.js-slider-group',
      },
      'copy-slider-content-col': {
        arrows: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: '.js-slider-group',
      },
      'full-image-slider': {
        fade: true,
        prevArrow: '<button class="slick-prev slick-arrow slick-arrow--icon text-white border-0" aria-label="Previous" type="button"><span class="icon-arrow-left"></span></button>',
        nextArrow: '<button class="slick-next slick-arrow slick-arrow--icon text-white border-0" aria-label="Next" type="button"><span class="icon-arrow-right"></span></button>',
      },
      'testimonial': {
        fade: true,
      },
    };

    const defaultOptions = {
      fade: false,
      rtl: true,
      swipe: false,
      prevArrow: '<button class="slick-prev slick-arrow slick-arrow--icon bg-transparent" aria-label="Previous" type="button"><span class="icon icon-arrow-left text-blue"></button>',
      nextArrow: '<button class="slick-next slick-arrow slick-arrow--icon bg-transparent" aria-label="Next" type="button"><span class="icon icon-arrow-right text-blue"></button>',
    };

    Object.keys( sliders ).map( ( el ) => {
      const options = sliders[ el ];
      const newOptions = Object.assign( {}, defaultOptions, options );

      this.initSlick( el, newOptions );
    });

  },

  initSlick( element, options ) {

    const slickElements = document.querySelectorAll( '[data-slider="' + element + '"]' );

    Object.keys( slickElements ).map( index => {
      const $slickElement = $( slickElements[ index ] );

      if ( $slickElement.parents( '.js-slider' ).find( '.js-slick-arrows' ).length > 0 ) {
        options.appendArrows = $slickElement.parents( '.js-slider' ).find( '.js-slick-arrows' );
      }

      $slickElement.slick( options );

    })

  },

  iconPagination( event ) {

    const key = parseInt( event.currentTarget.dataset.index );

    $( event.currentTarget ).parents( '.section' ).find( '.js-slider-group' ).slick( 'slickGoTo', key );

  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/slider.js